module.exports = "/_next/static/images/vomero-1c40d8557162af9687de66796e9874ea.jpg";